module.exports = __webpack_public_path__ + "img/treppenabgang.b68bea1a.webp";